import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import CustomForLoanModuleButtonTabs from "../../Components/ButtonTabs/CustomForLoanModuleButtonTabs";
import PersonalApproval from "./PersonalApproval";
import LoanDetailApproval from "./LoanDetailApproval";
import { APICall } from "../../Helpers/Network/APICalls";
import { useLocation } from "react-router-dom";
import { loanModuleGetPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import BankDetails from "../LoanApplication/BankDetails";
import LAPersonalDetails from "../LoanApplication/LAPersonalDetails";
import SurityDetails from "../LoanApplication/SurityDetails";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoanParams } from "../../Redux/Actions/LoanModuleAction";
import AgreementDisbursement from "../LoanApplication/AgreementDisbursement";
import LoanAmountDisbursement from "./LoanAmountDisbursement";
import AgreementDetails from "../LoanApplication/AgreementDetails";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { Typography } from "@mui/material";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import StatusApprovalScreen from "../LoanModule/StatusApprovalScreen";
import { MODES } from "../../Helpers/Enums/Enum";
import LALoanDetails from "../LoanApplication/LALoanDetails";
import LoanAgreementLetterHead from "../LoanApplication/LoanAgreementLetterHead";

const CustomTabPanel = (props: any) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} aria-disabled={false} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const LoanDetailDashboard = () => {
  const context = getContext();
  const [value, setValue] = useState(-1);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useContext(LoaderContext);

  useEffect(() => {
    getLoanDetails();
    getPersonalDetailsByIdApiCalllls();
  }, []);

  const getLoanDetails = async () => {
    showLoader();
    dispatch(setIsLoanParams({ LoanId: state?.Id, MemberId: context.MemberId }));
    setValue(0);
    hideLoader();
  };
  const [statusComponents, setStatusComponents] = useState<any>([]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  const getPersonalDetailsByIdApiCalllls = async () => {
    debugger
    showLoader();
    // let requestParams = { MemberId: MemberId };

    const res = await APICall(loanModuleGetPersonalDetailsByMemberId, {
      LoanId: state?.Id,
    });
    
    if (res.Message === "Ok" && res.Data !== null) {
      let statusComponents = [
        {
          isVisible: true,
          label: "Company Details", //"Employee Details",
          value: { ...a11yProps(0) },
          component: <LAPersonalDetails mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Loan Amount & Reason",
          value: { ...a11yProps(1) },
          isVisible: ![LoanStatus.LoanModule_PendingWithInternalTeam, LoanStatus.LoanModule_PendingMemberLoanConfirmation,LoanStatus.LoanModule_PendingWithHrHOD].includes(res?.Data?.Lrd_StatusId),
          component: <LALoanDetails mode={state?.mode} selectNextTab={() => 2} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Bank Details",
          value: { ...a11yProps(2) },
          isVisible: true,
          component: <BankDetails mode={state?.mode} selectNextTab={() => 3} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Surety Details",
          value: { ...a11yProps(3) },
          isVisible: true,
          component: <SurityDetails mode={state?.mode} selectNextTab={() => 3} selectPreviousTab={(index) => 1} />,
        },

        {
          label: "Loan Details",
          value: { ...a11yProps(3) },
          isVisible:
            [LoanStatus.LoanModule_PendingWithInternalTeam, LoanStatus.LoanModule_PendingMemberLoanConfirmation,LoanStatus.LoanModule_PendingWithHrHOD].includes(res?.Data?.Lrd_StatusId) &&
            [RoleEnum.InternalTeam, RoleEnum.LoanCommittee, RoleEnum.HRHOD].includes(context?.CurrentRoleId),
          component: <LoanDetailApproval mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Loan Details",
          value: { ...a11yProps(3) },
          isVisible: [LoanStatus.LoanModule_PendingMemberLoanConfirmation].includes(res?.Data?.Lrd_StatusId) && context?.CurrentRoleId === RoleEnum.Member,
          component: <LoanAmountDisbursement mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Download WorkSheet Calculation",
          value: { ...a11yProps(3) },
          isVisible:
            [
              LoanStatus.LoanModule_LoanAgreementPending,
              // LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
              LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            ].includes(res?.Data?.Lrd_StatusId) && context?.CurrentRoleId === RoleEnum.InternalTeam,
          component: <AgreementDetails mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Download Agreement Details",
          value: { ...a11yProps(3) },
          isVisible:
            [
              LoanStatus.LoanModule_LoanAgreementPending,
              // LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
              LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            ].includes(res?.Data?.Lrd_StatusId) && context?.CurrentRoleId === RoleEnum.InternalTeam,
          component: <LoanAgreementLetterHead mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Agreement Detail",
          value: { ...a11yProps(4) },
          isVisible:
            ([LoanStatus.LoanModule_MemberSignaturePending, LoanStatus.LoanModule_MemberSignatureVerificationRejected].includes(res?.Data?.Lrd_StatusId) &&
              context?.CurrentRoleId === RoleEnum.Member) ||
            ([LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam].includes(res?.Data?.Lrd_StatusId) &&
              context?.CurrentRoleId === RoleEnum.InternalTeam),
          component: <AgreementDisbursement mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Applicant details", //"Employee Details",
          value: { ...a11yProps(3) },
          isVisible:
            [
              LoanStatus.LoanModule_LoanCommitteeApprovalPending,
              LoanStatus.LoanModule_MemberAgreementRejected,
              LoanStatus.LoanModule_LoanFinalApprovalPending,
            ].includes(res?.Data?.Lrd_StatusId) && context?.CurrentRoleId === RoleEnum.LoanCommittee,
          component: <PersonalApproval mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
        {
          label: "Application Status",
          value: { ...a11yProps(3) },
          isVisible: context?.CurrentRoleId === RoleEnum.Member, //state.mode == MODES.EDIT ? false :
          component: <StatusApprovalScreen mode={state?.mode} selectNextTab={() => 1} selectPreviousTab={(index) => 1} />,
        },
      ];
      
      setStatusComponents(statusComponents.filter((status) => status.isVisible));
      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <CustomForLoanModuleButtonTabs value={value} handleChange={handleChange} tabs={statusComponents.filter((status) => status.isVisible)} />

      {statusComponents.length > 0 &&
        statusComponents.map((status, index) => {
          return (
            <React.Fragment key={index}>
              {status.isVisible && (
                <CustomTabPanel value={value} index={index}>
                  {status.component}
                </CustomTabPanel>
              )}
            </React.Fragment>
          );
        })}
    </Box>
  );
};

export default LoanDetailDashboard;
